import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import defaultUserPhoto from '../../../images/default_user.png';
import { dayMonthDate, timeFormatUi } from '../../../constants/date';
import { renderDay } from '../../../helpers/date';

export default class MessagesGroup extends Component {
  static propTypes = {
    conversation_id: PropTypes.number,
    sender: PropTypes.object.isRequired,
    messages: PropTypes.array.isRequired,
    showDayDelimiter: PropTypes.bool.isRequired,
    messageToScrollId: PropTypes.number,
    setMessageToScrollRef: PropTypes.func.isRequired
  };

  shouldComponentUpdate (nextProps) {
    return (nextProps.messages.length !== this.props.messages.length) || (nextProps.conversation_id !== this.props.conversation_id);
  }

  render () {
    const { sender, messages, showDayDelimiter, setMessageToScrollRef, messageToScrollId } = this.props;
    const senderFullName = `${sender.first_name} ${sender.last_name}`;
    const firstMessageDate = moment(messages[0].dc);
    const messagesList = messages.map(message => {
      const isMessageToScroll = messageToScrollId === message.id;
      return (
        <div key={message.id} className='message-wrapper'>
          <p className='message-body' ref={element => { isMessageToScroll && setMessageToScrollRef(element); }}>{message.body}</p>
          <p className='message-time'>{message.is_sms && '(sms)'} {moment(message.dc).format(timeFormatUi)}</p>
        </div>
      );
    });
    return (
      <React.Fragment>
        { showDayDelimiter && (
          <div className='delimiter-wrapper'>
            <hr />
            <p className='delimiter-date'>{renderDay(firstMessageDate, dayMonthDate)}</p>
            <hr />
          </div>
        )}
        <div className='participant-chat-item-wrapper'>
          <div
            className='participant-photo'
            style={{ backgroundImage: `url('${sender.photo_image_url || defaultUserPhoto}')` }}
          />
          <div className='chat-item-info'>
            <h5 className='participant-name'>{senderFullName}</h5>
            { messagesList }
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/messages/MessagesGroup.js